import { render, staticRenderFns } from "./MedicationAdminList.vue?vue&type=template&id=99ec9444"
import script from "./MedicationAdminList.vue?vue&type=script&lang=js"
export * from "./MedicationAdminList.vue?vue&type=script&lang=js"
import style0 from "./MedicationAdminList.vue?vue&type=style&index=0&id=99ec9444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports